/**
 * These are the names of the features we want to test and release,
 * will be used in local storage
 */
enum FeatureName {
  FEATURE_NAME_FOR_UNIT_TEST = 'FEATURE_NAME_FOR_UNIT_TEST', // Do-not-touch
  FEATURE_NAME_DEFAULT_ON_FOR_UNIT_TEST = 'FEATURE_NAME_DEFAULT_ON_FOR_UNIT_TEST', // Do-not-touch
  M1_FAST_FOLLOWS = 'M1_FAST_FOLLOW_FEATURES',
  BACKFILL_TAB = 'BACKFILL_TAB',
  M2_FEATURE = 'M2_FEATURE', // flag for m2 implementation
  DEV_TEST = 'DEV_TEST',
  // NextGenView
  NEXT_GEN_V2 = 'NEXT_GEN_V2',
}

/**
 * Features that are default to be on.
 * This is useful for features that are launched, but haven't been cleaned up.
 * They can still be explicitly turned off via K-Bar.
 */
export const DefaultOnFeatures = [
  FeatureName.FEATURE_NAME_DEFAULT_ON_FOR_UNIT_TEST, // Do-not-touch
] as FeatureName[];

export default FeatureName;
